export default Object.freeze({
  amountUpdated: "unlinkedPayments.amountUpdated",
  filter: "unlinkedPayments.filterList",
  recordsUpdated: "unlinkedPayments.recordsUpdated",
});
